module.exports = __webpack_public_path__ + "img/news-02.c55bad15.jpeg";